export default __webpack_public_path__ + "static/media/odi.bcc1687f.jpg";